import * as React from 'react';
import { noop } from 'lodash';

const styles: React.CSSProperties = {
    position: 'absolute',
    width: 0,
    height: 0,
    visibility: 'hidden',
    display: 'none',
};

interface SizeAwareWrapperProps {
    onResize: (width: number, height: number) => void;
    // This was to use width and height as props and then check to see if the values have changed inside the handleResize function
    // Some components need a double render to 'settle' and are using this so no check is needed.
    // However until that is fixed unit tests rely on these props so keeping as optional.
    // eslint-disable-next-line
    width?: number | string;
    // eslint-disable-next-line
    height?: number | string;
}

class SizeAwareWrapper extends React.PureComponent<SizeAwareWrapperProps, null> {
    ro: ResizeObserver | { observe(): void; unobserve(): void };

    el: HTMLDivElement;

    componentDidMount() {
        const resizableElement = this.getElement();
        if (resizableElement) {
            this.ro = this.getResizeObserver();
            this.ro.observe(resizableElement);
        }
    }

    componentWillUnmount() {
        const resizableElement = this.getElement();
        if (resizableElement && this.ro) {
            this.ro.unobserve(resizableElement);
        }
    }

    getElement = () => {
        const parentElement = this.el && this.el.parentElement;
        return parentElement;
    };

    getResizeObserver() {
        if (typeof ResizeObserver !== 'function') {
            return {
                observe() {},
                unobserve() {},
            };
        }
        return new ResizeObserver(this.handleResize);
    }

    handleResize = entries => {
        const { onResize = noop } = this.props;
        entries.forEach(entry => {
            const { width, height } = entry.contentRect;
            onResize(width, height);
        });
    };

    render() {
        return (
            <div
                key="resize-detector"
                style={styles}
                ref={el => {
                    this.el = el;
                }}
            />
        );
    }
}

export default SizeAwareWrapper;
